import React, { useReducer } from "react";
import Reducer from "./BusinessReducer";
import Context from "./BusinessContext";

const ForgotPass = (props) => {

  var initialState = { page1: null, page2: null, page3: null }

  const [passData, dispatchPassData] = useReducer(Reducer, initialState);

  return (
    <Context.Provider value={{ passData, dispatchPassData }}>
      {props.children}
    </Context.Provider>
  );
};

export default ForgotPass;